import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
const EventRegistrationStepHeader = ({ title, description, compact = false }) => (_jsxs(Box, { sx: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: description ? 0.5 : 0,
        pt: compact ? 1 : { xs: 1, sm: 1.25, md: 2, lg: 2.5 }
    }, children: [_jsx(Typography, { variant: 'h3', color: 'text.primary', children: title }), description && (_jsx(Typography, { variant: 'body2', color: 'text.secondary', children: description }))] }));
export default EventRegistrationStepHeader;
